import { writable, derived } from 'svelte/store';
import { antibodyTableService } from '../services/antibodyTableService';

function createTablesStore() {
    const { subscribe, set, update } = writable({
        tables: [],
        loading: false,
        error: null,
        lastFetch: null
    });

    return {
        subscribe,
        
        async fetchTables() {
            update(state => ({ ...state, loading: true, error: null }));
            
            try {
                const tables = await antibodyTableService.fetchTables();
                update(state => ({
                    ...state,
                    tables,
                    loading: false,
                    lastFetch: Date.now()
                }));
                return tables;
            } catch (error) {
                update(state => ({
                    ...state,
                    loading: false,
                    error: error.message
                }));
                throw error;
            }
        },

        async uploadTable(file, tableName) {
            update(state => ({ ...state, loading: true, error: null }));
            
            try {
                const table = await antibodyTableService.uploadTable(file, tableName);
                
                // Refresh tables list
                const tables = await antibodyTableService.fetchTables();
                update(state => ({
                    ...state,
                    tables,
                    loading: false
                }));
                
                return table;
            } catch (error) {
                update(state => ({
                    ...state,
                    loading: false,
                    error: error.message
                }));
                throw error;
            }
        },

        async deleteTable(tableId) {
            try {
                await antibodyTableService.deleteTable(tableId);
                
                // Refresh tables list
                const tables = await antibodyTableService.fetchTables();
                update(state => ({
                    ...state,
                    tables
                }));
                
                return true;
            } catch (error) {
                update(state => ({
                    ...state,
                    error: error.message
                }));
                return false;
            }
        },

        async updateTableName(tableId, newName) {
            try {
                const updatedTable = await antibodyTableService.updateTableName(tableId, newName);
                
                if (updatedTable) {
                    // Refresh tables list
                    const tables = await antibodyTableService.fetchTables();
                    update(state => ({
                        ...state,
                        tables
                    }));
                }
                
                return updatedTable;
            } catch (error) {
                update(state => ({
                    ...state,
                    error: error.message
                }));
                return null;
            }
        },

        clearCache() {
            antibodyTableService.clearCache();
            this.fetchTables();
        },

        reset() {
            set({
                tables: [],
                loading: false,
                error: null,
                lastFetch: null
            });
        }
    };
}

export const antibodiesStore = createTablesStore();

// Derived store for easy access to antibodies array
export const antibodies = derived(
    antibodiesStore,
    $antibodiesStore => $antibodiesStore.tables
);

// Derived store for loading state
export const antibodiesLoading = derived(
    antibodiesStore,
    $antibodiesStore => $antibodiesStore.loading
);

// Derived store for error state
export const antibodiesError = derived(
    antibodiesStore,
    $antibodiesStore => $antibodiesStore.error
);